export const meetWithAnand = "https://calendly.com/anandinkle/taxfiling";
export const ANAND_PHONE = "+16282774045";
export const ANAND_GENERIC_MEET_LINK = "https://calendly.com/anandinkle/30mins";
export const INKLE_CONSULTATION = "https://calendly.com/inklehq/inkle-support";
export const CPA_CONSULTATION =
  "https://calendly.com/inkle-admin/cpa-consultation";
export const ONBOARDING_LINK = "https://calendly.com/inklehq/onboarding";
export const DISCUSS_US_INDIA_STRUCTURING_WITH_ANAND =
  "https://www.inkle.ai/incorporate/demo";
export const BOOKKEEPING_CONSULTATION =
  "https://calendly.com/inklehq/bookkeeping-team";
export const SALES_DEMO = "https://calendly.com/inkle-sales/demo";
export const TAX_CALENDLY_LINK =
  "https://calendly.com/inklehq/30-minutes-chat-with-a-tax-expert";
